import React from 'react';
import styles from './TemplateSelected.module.scss';
import BtnRegistration from '../../common/BtnRegistration/BtnRegistration';
import { Button, Icon, Popconfirm, Tooltip } from 'antd';
import { useChangeRegistrationType } from '../HouseRegistrationTypeManager/api/changeRegistrationType';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDeleteTemplates } from '../HouseRegistrationTypeManager/api/deleteTemplates';
import { useChangeRegistrationTypesHouses } from '../HouseRegistrationTypeManager/api/changeRegistrationTypesHouses';
import { useConfigurationLSReg } from '../HouseRegistrationTypeManager/api/configurationLSReg';
import { registrationTypes } from '../../../constants/registrationTypes';
import { modeList } from '../../../constants/modeList';

const Tempalate = ({ selectedTemlates }) => {
  const processLinks = (html) => {
    return html?.replace(/<a\s+(?![^>]*\btarget=)[^>]*>/g, (match) =>
      match.replace('<a', '<a target="_blank" rel="noopener noreferrer"')
    );
  };

  const hasMessage2 = selectedTemlates.hasOwnProperty('message2');

  return (
    <>
      {hasMessage2 ? (
        <div className={styles.hasMessage2Block}>
          <div className={styles.countBlock}>1 блок:</div>
          <div className={styles.selected}>
            <div
              dangerouslySetInnerHTML={{
                __html: processLinks(selectedTemlates?.message),
              }}
              className={styles.message}
            ></div>
          </div>
          <div className={styles.countBlock}>2 блок:</div>
          <div className={styles.dopBlock}>
            Автоматический текст.
            <br />
            Из выбранных вами лицевых счетов мы покажем здесь доступные
            собственнику для регистрации (те, которые имеются у него в ЖФ)
            Пример:
            <br />
            {/* ЖКХ (УК "Одуванчики"), Домофон (Авентин, ООО "Домофончики") */}
            ЖКХ, Домофон
          </div>
          <div className={styles.countBlock}>3 блок:</div>
          <div className={styles.selected}>
            <div
              dangerouslySetInnerHTML={{
                __html: processLinks(selectedTemlates?.message2),
              }}
              className={styles.message}
            ></div>
          </div>
        </div>
      ) : (
        <div className={styles.selected}>
          <div
            dangerouslySetInnerHTML={{
              __html: processLinks(selectedTemlates?.message),
            }}
            className={styles.message}
          ></div>
        </div>
      )}
    </>
  );
};

const TemplateSelected = ({
  activeLsTypes,
  // arrearProviders,
  registrationTypeHouse,
  selectedTemlates,
  changeTemlateModem,
  housesData,
  setSelectedTemlates,
}) => {
  const history = useHistory();

  const { changeAsync, loading: loadingHouse } = useChangeRegistrationType();
  const { changeAsync: chengeHouses, loading: loadingHouses } =
    useChangeRegistrationTypesHouses();
  const { deleteAsync, loading: deleteLoading } = useDeleteTemplates();
  const { changeAsync: configurationLS, loading: loadingLS } =
    useConfigurationLSReg();

  const isLoading = loadingHouse || loadingHouses || loadingLS;
  const registrationTypePersonalAccounts =
    registrationTypeHouse.id === registrationTypes.personalAccounts.id;
  const hasServiceCompanyId = selectedTemlates?.serviceCompanyId;

  const houseData = useSelector(
    (state) => state.housingStockStore.currentHouse
  );
  const currentCompany = useSelector(
    (state) => state.housingStockStore.currentCompany
  );

  const handleChengeType = async () => {
    if (registrationTypePersonalAccounts) {
      const houses = housesData
        ? housesData.map((house) => house.houseId)
        : [houseData?.houseId];

      await configurationLS({
        houses,
        registrationType: registrationTypeHouse,
        arrearTypeIds: activeLsTypes,
        accessTypeId: selectedTemlates?.id,
        // arrearProviderIds: arrearProviders,
      });
    }

    if (registrationTypeHouse.id === registrationTypes.closed.id) {
      if (housesData) {
        await chengeHouses({
          housesArray: housesData,
          registrationType: registrationTypeHouse,
          HouseAccessTypeId: selectedTemlates?.id,
        });
      } else {
        await changeAsync({
          houseId: houseData?.houseId,
          registrationType: registrationTypeHouse,
          templateId: Number(selectedTemlates?.id),
        });
      }
    }

    history.push(`/HousingStock/company/${currentCompany?.id}/houses`);
  };

  const deleteFn = async (companyId, templateId) => {
    const res = await deleteAsync({
      serviceCompanyId: companyId,
      houseAccessTypeId: templateId,
      registrationTypeId: registrationTypeHouse?.id,
    });
    if (res?.success) {
      changeTemlateModem(modeList.NOTHING_MODE);
      setSelectedTemlates(null);
    }
  };

  const btnStyle = {
    color: 'white',
    fontFamily: 'Segoe UI',
    fontSize: '12px',
    fontWeight: '500',
    borderRadius: '8px',
    backgroundColor: '#0995ED',
  };

  return (
    <div className={styles.conteiner}>
      <div className={styles.header}>
        <div className={styles.blockButton}>
          {hasServiceCompanyId && (
            <>
              <Popconfirm
                placement="top"
                title={
                  <p>
                    Вы точно желаете удалить шаблон:{' '}
                    <strong>{selectedTemlates.name}</strong>?
                  </p>
                }
                onConfirm={() =>
                  deleteFn(currentCompany?.id, selectedTemlates?.id)
                }
                okText="Да"
                cancelText="Нет"
              >
                <BtnRegistration
                  loading={deleteLoading}
                  color="#E41C1C"
                  icon="delete"
                />
              </Popconfirm>
              <BtnRegistration
                title="Редактировать шаблон"
                text="Редактировать"
                onClick={() => changeTemlateModem(modeList.CHENGE_MODE)}
              />
            </>
          )}
        </div>
        <Tooltip title="Применить и сохранить шаблон">
          <Button
            style={btnStyle}
            type="primary"
            onClick={handleChengeType}
            loading={isLoading}
          >
            Применить и сохранить
            <Icon type="check" />
          </Button>
        </Tooltip>
      </div>
      <Tempalate selectedTemlates={selectedTemlates} />
    </div>
  );
};

export default TemplateSelected;
